import React from "react";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import styles from "../SettlementPortalLinkPopup.module.css";

function LinkTypeSelector({ selectedValue, onValueChange }) {
  return (
    <div>
      <RadioGroup
        row
        name="row-radio-buttons-group"
        value={selectedValue}
        onClick={(e) => {
          onValueChange(e.target.value);
        }}
        className={styles.link_type_selector}
      >
        <FormControlLabel value="url" control={<Radio />} label="URL" />
        <FormControlLabel
          value="alternative text"
          control={<Radio />}
          label="Alternative Text"
        />
        <FormControlLabel value="button" control={<Radio />} label="Button" />
      </RadioGroup>
    </div>
  );
}

export default LinkTypeSelector;
